var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c4d",
    d: "M8.76 17.518h3.336a.417.417 0 0 0 0-.834H8.76c-.69 0-1.251-.561-1.251-1.251v-4.171a.417.417 0 0 0-.834 0v4.17c0 1.15.935 2.086 2.085 2.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c4d",
    d: "M.417 9.176H8.76a.417.417 0 0 0 0-.834H.417a.417.417 0 0 0 0 .834z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c4d",
    d: "M18.353.834c.46 0 .834.375.834.834v15.016c0 .357-.23.674-.574.79l-5.005 1.668c-.548.194-1.095-.244-1.095-.79V3.338a.83.83 0 0 1 .574-.788L18.092.88a.768.768 0 0 1 .26-.046zm-5.006 19.187c.184 0 .363-.03.533-.09l4.997-1.667a1.667 1.667 0 0 0 1.144-1.58V1.668A1.67 1.67 0 0 0 18.353 0c-.186 0-.366.03-.533.092l-4.996 1.665a1.665 1.665 0 0 0-1.145 1.58v15.016c0 .92.748 1.668 1.668 1.668z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c4d",
    d: "M7.09 6.674c.231 0 .418-.187.418-.417V2.086c0-.69.561-1.252 1.251-1.252h9.594a.417.417 0 0 0 0-.834H8.759C7.61 0 6.674.936 6.674 2.086v4.17c0 .23.187.418.417.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c4d",
    d: "M3.754 12.513a.417.417 0 0 0 .295-.712l-3.041-3.04 3.041-3.042a.417.417 0 0 0-.59-.59L.123 8.466a.417.417 0 0 0 0 .59l3.336 3.336c.081.08.188.121.295.121z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.4bd4c1648bcc53aae34ab406903160cf.svg";
export { ForwardRef as ReactComponent };